import script from "./AccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountModal.vue?vue&type=style&index=0&id=2330a760&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2330a760"]])

export default __exports__